import { Button, JsonEditor } from '@sloyd/ui';
import { bridge, Unity, useUnity } from '@sloyd/viewer';
import { useState } from 'react';
import { useMeasure } from 'react-use';
import { defaultValue } from './PageJson.data';
import { Actions, Column, Wrapper } from './PageJson.style';

export type PageJsonProps = {
  instanceId?: string;
};

export function PageJson(props: PageJsonProps) {
  const { instanceId = 'main' } = props;
  const { unityProvider, isLoaded } = useUnity();
  const [ref, { width, height }] = useMeasure<HTMLDivElement>();
  const [value, setValue] = useState<string>(JSON.stringify(defaultValue, null, 4));

  function onChange(newValue: string) {
    setValue(newValue);
  }

  function onRender() {
    bridge.replaceModel(instanceId, value);
  }

  return (
    <Wrapper className='PageJson-wrapper' data-testid='PageJson-wrapper'>
      <Column>
        <JsonEditor onChange={onChange} value={value} />
        <Actions>
          <Button onClick={onRender}>Render</Button>
        </Actions>
      </Column>
      <Column ref={ref}>
        <Unity
          unityProvider={unityProvider}
          style={{
            height,
            width,
          }}
          matchWebGLToCanvasSize={true}
          devicePixelRatio={devicePixelRatio}
        />
      </Column>
    </Wrapper>
  );
}

export default PageJson;
